import axios from "axios";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });
const base = `${API}/api/commissions/admin`;

export const cget = (path, params) => axios.get(`${base}${path}`, { ...auth(), params }).then((r) => r.data);
export const cput = (path, body) => axios.put(`${base}${path}`, body, auth()).then((r) => r.data);
export const cpost = (path, body) => axios.post(`${base}${path}`, body, auth()).then((r) => r.data);
export const mget = () => axios.get(`${API}/api/membership/admin/config`, auth()).then((r) => r.data);
export const mcomp = (body) => axios.post(`${API}/api/membership/admin/comp`, body, auth()).then((r) => r.data);
export const mput = (body) => axios.put(`${API}/api/membership/admin/config`, body, auth()).then((r) => r.data);
export const errText = (e) => {
  const d = e?.response?.data?.detail;
  return typeof d === "string" ? d.replace(/_/g, " ") : "Something went wrong";
};
export const gbp = (v) => `${v < 0 ? "-" : ""}£${Math.abs(v || 0).toFixed(2)}`;
export const thisMonth = () => new Date().toISOString().slice(0, 7);

export const openPdf = async (path) => {
  const r = await axios.get(`${API}/api/commissions${path}`, { ...auth(), responseType: "blob" });
  window.open(URL.createObjectURL(r.data), "_blank");
};

export const downloadTide = async (ym) => {
  const r = await axios.get(`${base}/payouts/tide.csv`, { ...auth(), params: { ym }, responseType: "blob" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(r.data);
  a.download = `tide-payouts-${ym}.csv`;
  a.click();
  return Number(r.headers["x-tide-skipped"] || 0);
};

export const inputCls = "rounded-lg border border-[#e5e0d3] bg-white px-2.5 py-1.5 text-sm";
export const btnCls = "rounded-full bg-[#2b2b2b] px-4 py-1.5 text-sm text-white transition-colors hover:bg-black disabled:opacity-50";
